import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import { formatVerificationDate } from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';

import './BrusselsWatermark.scss';

const BrusselsWatermark = ({ verificationDate }) => {
  return (
    <div className="brussels-watermark__container">
      {trans('listing.homechecker.verificationDate.subtitle', {
        date: formatVerificationDate(verificationDate)
      })}
    </div>
  );
};

BrusselsWatermark.propTypes = {
  verificationDate: PropTypes.string.isRequired
};

export default BrusselsWatermark;
